import Service from '../service/Service';
const service = new Service();
var jcrop_api;

export function slideLeft(id, keyVal, eleRef, tool) {
    if (id > keyVal) {
        weekInfo(id - 1, eleRef, keyVal, tool);
    }
}

export function slideRight(id, keyVal, eleRef, tool) {
    if (id < 40) {
        weekInfo(id + 1, eleRef, keyVal, tool);
    }
}
export function changeTabTextColor(eleRef) {
    if (window.innerWidth > 767) {
        for (let i = 0; i < eleRef.state.cardList.length; i++) {
            eleRef.state.cardListmonth[i].classList["value"] = "month-old R14_9e";
            if (eleRef.state.cardList[i].classList.contains('active')) {
                eleRef.state.cardList[i].firstElementChild.lastChild.classList['value'] = 'month-old R14_pink';
            }
        }
    } else {
        for (let i = 0; i < eleRef.state.cardList.length; i++) {
            eleRef.state.cardListmonth[i].classList["value"] = "month-old R11_9e";
            if (eleRef.state.cardList[i].classList.contains('active')) {
                eleRef.state.cardList[i].firstElementChild.lastChild.classList['value'] = 'month-old R11_pink';
            }
        }
    }
}

export function calScrollTop(left, id,val,eleRef) {
    eleRef.state.cardsTotalHeight = 0;
    for (var m = 6; m < left; m++) {
        if ((window).outerWidth > 767) {
            eleRef.state.cardsTotalHeight += (document.querySelector('#month-card-' + m).offsetHeight + val);
          }
          else{
            eleRef.state.cardsTotalHeight += (document.querySelector('#month-card-' + m).offsetHeight);
          }
    }
    return eleRef.state.cardsTotalHeight;
}

export function isInViewport(el) {
    // console.log("element===============>",el);
    const scroll = window.scrollY || window.pageYOffset
    const boundsTop = el.getBoundingClientRect().top + scroll
    const viewport = {
        top: scroll,
        bottom: scroll + window.innerHeight,
    }
    const bounds = {
        top: boundsTop,
        bottom: boundsTop + el.clientHeight,
    }
    if(window.innerWidth < 767){
        return el.getBoundingClientRect().top >= 0 && el.getBoundingClientRect().bottom <= window.innerHeight
    }else{
        return (bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom)
        || (bounds.top <= viewport.bottom && bounds.top >= viewport.top);
    }
}
// export function isInViewport(el) {
//     var elementTop = el.getBoundingClientRect().top + window.scrollY;
//     var elementBottom = elementTop + el.offsetHeight;
//     var viewportTop = window.pageYOffset;
//     if(window.innerHeight > 710 && window.innerWidth < 767){
//         var viewportBottom = viewportTop + window.innerHeight/2;
//     }else{
//         var viewportBottom = viewportTop + window.innerHeight;
//     }
//     return elementBottom > viewportTop && elementTop < viewportBottom
// }
export function slideStage(e,eleRef) {
    if (navigator.onLine) {
        if (e.target.parentElement.classList.contains('next')) {
            document.querySelector(".month-slider").scrollLeft = (document.querySelector(".month-slider").scrollLeft + 114);
            eleRef.state.myactiveStage += 114;
        } else {
            document.querySelector(".month-slider").scrollLeft = document.querySelector(".month-slider").scrollLeft - 114;
            eleRef.state.myactiveStage -= 114;
        }
    } else {
        service.hideLoader();
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
}

export function calScrollLeft(id ,val) {
    console.log("calScrolleft===========>",val);
    let id1 = parseInt(id);
    let monthSliderWidth = document.querySelector('.month-slider').offsetWidth;
    let tablinkBorderWidth = 1;
    let tablinkMarRight = 14;
    if (window.innerWidth < 767) {
        tablinkMarRight = 10;
        tablinkBorderWidth = 2
    }
    let tablinkWidth = (document.querySelector('.tablink') ? document.querySelector('.tablink').offsetWidth : 0) + (2 * tablinkBorderWidth);
    let tablinkTotalWidth = tablinkWidth + tablinkMarRight;

    let noOfTablink = (monthSliderWidth / tablinkTotalWidth) / 2;

    let activelinkLeft = (tablinkWidth * (noOfTablink - Math.floor(noOfTablink))) + (tablinkTotalWidth * (Math.floor(noOfTablink) - 1)) + (tablinkWidth / 2);

    if ((id1 + Math.floor(noOfTablink)) > val) {
        return document.querySelector('.month-slider').firstElementChild.offsetWidth;
    } else {
        return ((tablinkTotalWidth * (id1 - 1)) - activelinkLeft)
    }
}

export function weekInfo(weekno, eleRef, keyVal, tool) {
    if (navigator.onLine) {
        console.log("weekInfo==============>",weekno);
        eleRef.setState({ clickwedWeek: weekno });
        let currentindex = weekno - keyVal;
        let scrolllft = 0;
        for (let i = 1; i <= document.querySelectorAll('.week-bar li').length; i++) {
            let wd = i * eleRef.state.weekwd;
            if (wd > eleRef.state.halfwidth) {
                if (currentindex >= i - 1) {
                    scrolllft = ((currentindex - (i - 1)) * eleRef.state.weekwd);
                    if (tool == 'pis') {
                        let maxScroll = document.getElementsByClassName('pregn-reports-cnt')[0].offsetWidth - document.getElementsByClassName('preg-scroll')[0].offsetWidth;
                        scrolllft = scrolllft <= maxScroll ? scrolllft : maxScroll;
                        document.querySelector('.preg-scroll').scrollLeft = scrolllft;
                        document.getElementsByClassName('pregnancy-reports')[0].style.width = (document.getElementsByClassName('preg-scroll')[0].offsetWidth + scrolllft) + 'px';
                    } else {
                        let maxScroll = 0;
                        if (document.getElementsByClassName('week-bar') && document.getElementsByClassName('weeks-section')) {
                            maxScroll = document.getElementsByClassName('week-bar')[0].offsetWidth - document.getElementsByClassName('weeks-section')[0].offsetWidth;
                        }
                        scrolllft = scrolllft <= maxScroll ? scrolllft : maxScroll;
                        document.querySelector('.weeks-section').scrollLeft = scrolllft;
                    }
                    break
                } else {
                    if (tool == 'pis') {
                        document.querySelector('.preg-scroll').scrollLeft = scrolllft;
                        document.getElementsByClassName('pregnancy-reports')[0].style.width = document.getElementsByClassName('preg-scroll')[0].offsetWidth + 'px';
                    } else {
                        document.querySelector('.weeks-section').scrollLeft = scrolllft;
                    }
                    break
                }
            }
        }
        if (tool == 'bsc') {
            if (eleRef.state.babysizecomparisonData[weekno - keyVal]) {
                let articleCnt = eleRef.state.babysizecomparisonData[weekno - keyVal]['articles'].length;
                if (articleCnt > 0) {
                    let sliderFullWidth = (eleRef.state.sliderWidth + eleRef.state.marginRight) * articleCnt;
                    eleRef.setState({ sliderFullWidth: (sliderFullWidth + 10) + "px" });
                    // document.getElementById('sliderId').style.width = sliderFullWidth + "px"
                }
                let babylength = eleRef.state.babysizecomparisonData[weekno - keyVal].averageLength;
                document.querySelector('.baby-len').innerHTML = babylength;
                let babyweight = eleRef.state.babysizecomparisonData[weekno - keyVal].averageWeight;
                document.querySelector('.baby-wt').innerHTML = babyweight;
                eleRef.state.typename = document.querySelector('.selected').innerText.split(" ")[2];
                let imgtype = document.querySelector('.selected').innerText.split(" ")[2];
                eleRef.imagetype(imgtype);
                setTimeout(function () {
                    document.querySelector('.articles-slider').scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                }, 100)
            }
        } else if (tool == 'wbw') {
            eleRef.selectimage(weekno, "scan_2D");
        } else if (tool == 'pis') {
            eleRef.setTrimesterText(weekno);
        }else if(tool == 'wbwG'){
            setTimeout(()=>{
            console.log("eleRef.state.clickwedWeek=========>",eleRef.state.clickwedWeek);
                document.querySelector('.baby-sizeCurrWk').innerText=(eleRef.state.clickwedWeek);
                document.querySelector('.length').innerHTML=(eleRef.state.WeekByweekdata[eleRef.state.clickwedWeek-1].length);
                document.querySelector('.weight').innerHTML=(eleRef.state.WeekByweekdata[eleRef.state.clickwedWeek-1].weight);
                document.querySelector('.trimester').innerHTML=(eleRef.state.WeekByweekdata[eleRef.state.clickwedWeek-1].trimester);
                if (!global.ftk || global.userAry['childData']['UserChildList'] == null || global.userAry['childData']['UserChildList'].length == 0 || !eleRef.state.IsExpected) {
                        document.querySelector('.trimesterdays').display='none';
                    } else if (eleRef.state.WeekByweekdata[eleRef.state.clickwedWeek-1].week == 40 && eleRef.state.WeekByweekdata[eleRef.state.clickwedWeek-1].daysLeft < 1) {
                            document.querySelector('.trimesterdays').display='none';
                        } else {
                                document.querySelector('.trimesterdays').display='show';
                                document.querySelector('.trimesterdays').innerText=(" | " + eleRef.state.WeekByweekdata[eleRef.state.clickwedWeek-1].daysLeft + " days left");
                            }
            },50);
            eleRef.selectimage(weekno, "scan_2D");
        }
    } else {
        service.hideLoader();
        service.showAlert("Please Check Internet Connection!!!");
        return false;
    }
}

export function shareOn(id) {
    let ary = document.getElementsByClassName('sharing-options');
    // console.log("shareon "+ary.length);
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    // console.log(ary);
    // console.log(document.querySelector('.articles-section').getElementById('share_' + id));
    document.getElementById('share_' + id).getElementsByClassName('sharing-options')[0].style.display = 'block';

    if (window.innerWidth < 767) {
        document.getElementsByClassName('share-overlay')[0].style.display = 'block';
    }
}

export function shareArticle(shareoption, articleurl) {
    var shareurl;
    if (!articleurl.includes('http')) {
        articleurl = 'https:' + articleurl;
    }
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    if(document.getElementsByClassName('share-overlay')){
        document.getElementsByClassName('share-overlay')[0].style.display = 'none';
    }
    if (shareoption === "facebook") {
        shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (shareoption === "twitter") {
        shareurl = 'https://twitter.com/share?url=';
    } else if (shareoption === "pintrest") {
        shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    } else if (shareoption === "whatsapp") {
        shareurl = 'whatsapp://send?text=';
    }
    var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    console.log("sharewindow " + sharewindow);
    if (sharewindow.focus) {
        sharewindow.focus();
    }
    return false;
}

export function domClick(event) {
    // console.log("windowclick");
    if (!event.target.classList.contains('share-icon') && !event.target.classList.contains('share-text')) {
        let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'none';
        }
    }
}
export function duDateQans(id) {
    if (document.getElementById(id).firstElementChild.nextSibling.style.display != "none") {
        document.getElementById(id).firstElementChild.style.marginBottom = "10px"
        document.getElementById(id).nextSibling.style.display = "block";
        document.getElementById(id).firstElementChild.nextSibling.style.display = "none";
        document.getElementById(id).firstElementChild.nextSibling.nextSibling.style.display = "block";
    }
    else {
        document.getElementById(id).firstElementChild.style.marginBottom = "0px"
        document.getElementById(id).nextSibling.style.display = "none";
        document.getElementById(id).firstElementChild.nextSibling.style.display = "block";
        document.getElementById(id).firstElementChild.nextSibling.nextSibling.style.display = "none";
    }
}
export function loopCycle() {
    for (var i = 21; i < 36; i++) {
        <option value={i}>{i}</option>
    }
}

// export function Disclaimer(eleRef) {
//     eleRef.props.history.push("/tools/pregnancy-due-date-calculator/disclaimer");
// }

// export function FAQs(eleRef) {
//     eleRef.props.history.push("/tools/pregnancy-due-date-calculator/faqs");
// }

export function getPragnancyTrimesterText(week) {
    week = parseInt(week);
    let text = '';
    if (week <= 12) {
        text = "First Trimester";
    } else if (week <= 26 && week > 12) {
        text = "Second Trimester";
    } else if (week > 26) {
        text = "Third Trimester";
    }
    return text;
}

export function getDateStringPis(date) {
    if (date) {
        let monthAry = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        let dateObj = new Date(date.replace(/-/g, '/'));
        var strDate = (dateObj.getDate() > 9 ? dateObj.getDate() : "0" + dateObj.getDate()) + " " + monthAry[dateObj.getMonth()] + " " + dateObj.getFullYear();
        return strDate;
    } else {
        return "";
    }
}

export function getTimeStringPis(date) {
    if (date) {
        let dateObj = new Date(date.replace(/-/g, '/'));
        var hours = dateObj.getHours();
        var minutes = dateObj.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    } else {
        return "";
    }
}

export function getTimeValPis(date) {
    if (date) {
        let dateObj = new Date(date.replace(/-/g, '/'));
        var hours = dateObj.getHours();
        var minutes = dateObj.getMinutes();
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes;
        return strTime;
    } else {
        return "";
    }
}

export function removeSelfClass(add, remove) {
    setTimeout(() => {
        let count = document.querySelectorAll('.' + add).length;
        for (let i = 0; i < count; i++) {
            document.querySelectorAll('.' + add)[i].classList.add(remove);
        }
        let count1 = document.querySelectorAll('.' + remove).length;
        for (let j = 0; j < count1; j++) {
            document.querySelectorAll('.' + remove)[j].classList.remove(add);
        }
    }, 1000);
}

export function closeEmailPopup(event) {
    document.querySelector(".email-overlay").style.display = "none";
    // document.querySelector(".email-tooltip").style.display = "none";
    // document.querySelector('.type-msg').value="";
}

export function sendFetusEmail() {
    if (global.ftk != '') {
        var to = document.querySelector('#email_to').value;
        var emailText = document.querySelector('.type-msg').value;
        var validEmail = true;
        var result = to.split(",").map((email, index) => email.trim()).filter(email => {
            if (!(email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/))) {
                validEmail = false;
               
                document.getElementById("EmailIdErrMs").style.display = "block";
            }
        });
        service.showLoader();

        {
         to.split(",").map(email => email.trim()).filter(email => {
            if (to=="") {
                validEmail = false;
                document.getElementById("EmailIdErrMs").style.display = "block"
            }
            emailText = emailText.trim();
            if (emailText == "") {
                validEmail = false;
                document.getElementById("MsgErrMs").style.display = "block"
            }

            if (emailText != "" && to != "" && (email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) && validEmail == true) {

            var postData = {
                "emailTo": to,
                "emailText": emailText
            }
            var url = global.api_ci_url + "Fetus/sendFetusEmail";
            service.postServiceCall(url, postData).then((json) => {
                service.hideLoader();
                document.getElementById("EmailIdErrMs").style.display = "none";
                document.getElementById("MsgErrMs").style.display = "none";
                service.showAlert("Mail sent successfully.");
                document.querySelector('.email-overlay').style.display = 'none';

            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
            return true;
            }
        }
        )
        }    
        service.hideLoader();
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}
export function selected_contest(title, contestId,eleRef) {
    if (document.querySelector(".selected_option") != null) {
        document.querySelector(".selected_option").innerHTML = title;
    }
    eleRef.state.contestId = contestId;
    document.querySelector(".options_overlay").style.display = "none";
    document.querySelector("#selconst").innerHTML = title;
    document.querySelector("#selconst").classList.add("R15_42");
    document.querySelector("#selconst").classList.remove("R15_9e");
    // document.querySelector(".shareicon").attr("data-icon-font", "A"),
    // document.querySelector("#sharepic").addClass("isChecked")
}
export function showOptions() {
    if (window.innerWidth < 767) {
        var e = window.innerWidth - document.querySelector(".option_list").offsetWidth;
        document.querySelector(".option_list").css = ("left", e / 2)
    }
    document.querySelector(".options_overlay").style.display = "block";
}
export function myProfile_status(e) {
    if (e.target.classList.contains('isChecked')) {
        e.target.classList.remove('isChecked');
        e.target.setAttribute('data-icon-font', "z");
    } else {
        e.target.value = 1;
        e.target.classList.add('isChecked');
        e.target.setAttribute('data-icon-font', "A");
    }
}
export function SlideTag(e,eleRef) {
    if (eleRef.state.insertIds.length < 1 && (document.querySelector(".slide-tag-active") == null || document.querySelector(".slide-tag-active"))) {
        if (document.querySelector(".slide-tag-active") != null) {
            for (var a = 0; a < document.querySelector(".slide-tag-active").length; a++) {
                eleRef.state.insertIds.push(document.querySelector(".slide-tag-active")[a].getAttribute("data-id"));
            }
        }
        if (e.target.getAttribute("data-id") == "1" && document.querySelector(".tagkids_1").classList.contains("slide-tag-active")) {
            document.querySelector(".tagkids_1").classList.remove("slide-tag-active");
            document.querySelector("#setmyselfval").value = "0";
        } else {
            document.querySelector(".tagkids_1").classList.remove("slide-tag-active");
            document.querySelector(".tagkids_1").classList.add("slide-tag-active");
            document.querySelector("#setmyselfval").value = "1";
        }
    }
}
// export function checkCoords(eleRef) {
//     console.log("test " + eleRef.state.cropy + "test" + eleRef.state.cropheight + " " + eleRef.state.cropwidth + " " + eleRef.state.cropx);
//     if ((eleRef.state.cropwidth && eleRef.state.cropheight) || (eleRef.state.cropwidth === 0 && eleRef.state.cropheight == 0)) {
//         const croppedImageUrl = eleRef.getCroppedImg(document.querySelector('#main_frame').src);
//         eleRef.setState({ croppedImageUrl });
//     }
// }
export function checkCoords(eleRef,tool) {
    // var size = {
    //     x: parseInt($('#rx').val()),
    //     y: parseInt($('#ry').val()),
    //     w: parseInt($('#rw').val()),
    //     h: parseInt($('#rh').val())
    // };
    //     var imageObj = $("#cropbox")[0];
    //     var canvas = $("#preview")[0];
    //     var context = canvas.getContext("2d");
    //     canvas.width = 1000;
    //     canvas.height = 1000;
    //     context.drawImage(imageObj, size.x, size.y, size.w, size.h, 0, 0, canvas.width, canvas.height);
    //     var url = canvas.toDataURL();
    //     var file = dataURItoFile(url);
    //     uploadMemoryImgSubmit(file, eleRef);

    if(tool=="FB"){
        $(".loader-overlay").show();
        var size = {
            x: parseInt($('#rx').val()),
            y: parseInt($('#ry').val()),
            w: parseInt($('#rw').val()),
            h: parseInt($('#rh').val())
        };
        var frameDataURL;
        frameDataURL = new Image();
        frameDataURL.crossOrigin = "Anonymous";
        frameDataURL.onload = function () {
            var imageObj = $("#cropbox")[0];
            var canvas = $("#preview")[0];
            var context = canvas.getContext("2d");
            canvas.width = $('#main_frame').width();
            canvas.height = $('#main_frame').height();
            context.drawImage(imageObj, size.x, size.y, size.w, size.h, 0, 0, canvas.width, canvas.height);
            context.drawImage(frameDataURL, -1, -1, canvas.width + 2, canvas.height + 2);
            var offset_mf = $('#main_frame').offset();
            var date_ele = $('.face_date_container_uf');
            var offset_date = date_ele.offset();
            var date_x = offset_date.left - offset_mf.left;
            if ($(window).width() < 767) {
                var date_y = offset_date.top - offset_mf.top - 2
            } else {
                var date_y = offset_date.top - offset_mf.top
            }
            var f_date = date_ele.html();
            var f_font_family = date_ele.css('font-family');
            var f_font_size = date_ele.css('font-size');
            var f_font_weight = date_ele.css('font-weight');
            context.font = f_font_weight + " " + f_font_size + " " + f_font_family;
            var gradient = context.createLinearGradient(0, 0, 1, 1);
            gradient.addColorStop("0", "#fff");
            gradient.addColorStop("1", "#fff");
            context.fillStyle = gradient;
            context.fillText(f_date, date_x, date_y + 25);
            var url = canvas.toDataURL();
            var file = dataURItoFile(url,"face_upload");
            uploadMemoryImgSubmit(file,eleRef,tool);
        };
        frameDataURL.src = $("#main_frame").attr('src')
    }else{
        $(".loader-overlay").show();
        var e, a = {
            x: parseInt($("#rx").val()),
            y: parseInt($("#ry").val()),
            w: parseInt($("#rw").val()),
            h: parseInt($("#rh").val())
        };
        (e = new Image).crossOrigin = "Anonymous", e.onload = function () {
            var t = $("#cropbox")[0],
                i = $("#preview")[0],
                r = i.getContext("2d");
            i.width = 1032, i.height = 1111, r.drawImage(t, a.x, a.y, a.w, a.h, 0, 0, i.width, i.height), r.drawImage(e, -1, -1, i.width + 2, i.height + 2), uploadMemoryImgSubmit(dataURItoFile(i.toDataURL(),"mybumpie_upload"),eleRef,tool)
        }, e.src = $("#main_frame").attr("src")
    }    
}
function dataURItoFile(dataURI,ids) {
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new File([ia], document.getElementById(ids).files[0]['name'], { type: mimeString });
    
}
function uploadMemoryImgSubmit(file, eleRef,tool) {
    var ids=tool;
    service.showLoader();
    var file_name = Math.round(new Date().getTime() / 1000) + "_" + file.name;
    // var apiurl = global.api_url + "uploadMemoryImage";
    var apiurl = global.api_ci_url + "Parenting/uploadMemoryImage";
    service.postFileServiceCall(apiurl, file, file_name).then((json) => {
        console.log(json);
        if (json['result'] == "success") {
            console.log("success");
            eleRef.setState({
                cropedImagePath: json['image_url'].replace("http://", "https://")
            });
            if (json['image_url']) {
                document.getElementById("main_frame").setAttribute("src", json['image_url'].replace("http://", "https://"));
            } else {
                document.getElementsByClassName('file_upload_err')[0].style.height = "10px";
                $('.file_upload_err').hide();
                $('.file_upload_err').html("")
            }
            document.querySelector('.add_photo_lbl').style.display = "none";
            document.getElementsByClassName('photo_frame')[0].style.height = 'auto';
            document.getElementsByClassName('photo_frame')[0].style.backgroundColor = '#fff';
            document.getElementById('main_frame').style.display = "block";
            document.querySelector('.choose_photo_btns').style.display = "none";
            if(tool=="FB"){
                document.querySelector('.face_date_container_uf').style.display = "none";
            }
            document.querySelector('.upload_photo_btns').style.display = "block";
        } else {
            document.getElementsByClassName('file_upload_err')[0].style.visibility = "visible";
            document.getElementsByClassName('file_upload_err')[0].style.height = "30px";
            $('.file_upload_err').show();
            $('.file_upload_err').html(json.result);
            service.showAlert("Fail");
        }
        clearMemoryImageData(eleRef,ids,true);
        service.hideLoader();
    }).catch((error) => {
        console.error(error);
        service.hideLoader();
    });
}
// export function dataURItoFile(dataURI,ids) {
//     console.log("dataURItoFile");
//     var byteString;
//     if (dataURI.split(',')[0].indexOf('base64') >= 0)
//         byteString = atob(dataURI.split(',')[1]);
//     else
//         byteString = unescape(dataURI.split(',')[1]);
//     var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
//     var ia = new Uint8Array(byteString.length);
//     for (var i = 0; i < byteString.length; i++) {
//         ia[i] = byteString.charCodeAt(i);
//     }
//     return new File([ia], document.getElementById(ids).files[0]['name'], { type: mimeString });
// }
// export function clearMemoryImageData(ids) {
//     console.log("clearMemoryImageData");
//     document.getElementsByClassName('uploadImg-overlay')[0].style.display = "none";
//     document.getElementsByTagName('body')[0].style.overflow = 'visible';
//     document.getElementById(ids).value = '';
//     document.getElementsByClassName('img_cntner')[0].style.height = 'auto';
// }
export function clearMemoryImageData(eleRef,tool,flag) {
    var ids;
    if(tool=="MB"){
        ids="mybumpie_upload";
    }else{
        ids="face_upload";
    }
    eleRef.setState({ isMemorySelected: flag }, () => {
        document.getElementById(ids).value = null;
        $('.uploadImg-overlay').hide();
        $('body').css("overflow", "visible");
        $('#cropbox').attr('src', "");
        jcrop_api = $('#cropbox').data('Jcrop');
        jcrop_api.destroy();
        var canvas = $("#preview")[0];
        var context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height);
        $('.img_cntner').css('width', 'auto');
        $('.img_cntner').css('height', 'auto');
        $('#cropbox').removeClass('landCropbox');
        $('#cropbox').removeClass('portCropbox');
        $('#cropbox').removeClass('normalCropbox');
        if ($(window).width() < 767) {
            $('#cropbox').width(0);
        }
    });
}
export function afterJcropFilesLoaded(fileObj) {
    // var w = 0;
    // var h = 0;
    // var _URL = window.URL || window.webkitURL;
    // var file, img;
    // file = fileObj;
    // img = new Image();
    // img.onload = function () {
    //     w = this.width;
    //     h = this.height;
    //     if ($(window).width() > 767) {
    //         if (w > h) {
    //             if ((w / h) > 2) {
    //                 $('#cropbox').addClass('landCropbox');
    //             } else {
    //                 $('.img_cntner').css('height', '300px');
    //                 $('#cropbox').addClass('portCropbox');
    //             }
    //         } else if (w < h) {
    //             $('.img_cntner').css('height', '300px');
    //             $('#cropbox').addClass('portCropbox');
    //         } else {
    //             $('.img_cntner').css('width', '300px');
    //             $('.img_cntner').css('height', '300px');
    //             $('#cropbox').addClass('normalCropbox');
    //         }
    //         if (h > 400) {
    //             $('.uploadImg-popup').css('top', '10%');
    //         }
    //     } else {
    //         if (w < h) {
    //             if (((($(window).width() - 40) * h) / w) > ($(window).width() - 40)) {
    //                 $('.img_cntner').css('height', '300px');
    //                 $('#cropbox').addClass('portCropbox');
    //             }
    //         }
    //     }
    //     var reader = new FileReader();
    //     reader.onload = function (e) {
    //         var fWidth = 1000;
    //         var fHeight = 1000;
    //             fWidth = $('.uploaded-img #memoryimg').width() * 3;
    //             fHeight = $('.uploaded-img #memoryimg').height() * 3;
    //         $("#preview").width(fWidth);
    //         $("#preview").height(fHeight);
    //         $('#cropbox').attr('src', e.target.result);
    //         $('#cropbox').Jcrop({
    //             aspectRatio: fWidth / fHeight,
    //             setSelect: [0, 0, 200, 200],
    //             boxWidth: 675,
    //             allowResize: true,
    //             onSelect: updateCoords
    //         });
    //     };
    //     reader.readAsDataURL(file);
    // };
    // img.src = _URL.createObjectURL(file);
    // $('.uploadImg-overlay').show();
    // $('body').css("overflow", "hidden");
    var w = 0;
        var h = 0;
        var _URL = window.URL || window.webkitURL;
        var file, img;
        file = fileObj;
        img = new Image();
        img.onload = function () {
            w = this.width;
            h = this.height;
            if ($(window).width() > 767) {
                if (w > h) {
                    if ((w / h) > 2) {
                        $('#cropbox').addClass('landCropbox')
                    } else {
                        $('.img_cntner').css('height', '300px');
                        $('#cropbox').addClass('portCropbox')
                    }
                } else if (w < h) {
                    $('.img_cntner').css('height', '300px');
                    $('#cropbox').addClass('portCropbox')
                } else {
                    $('.img_cntner').css('width', '300px');
                    $('.img_cntner').css('height', '300px');
                    $('#cropbox').addClass('normalCropbox')
                }
                if (h > 400) {
                    $('.uploadImg-popup').css('top', '10%')
                }
            } else {
                if (w < h) {
                    if (((($(window).width() - 40) * h) / w) > ($(window).width() - 40)) {
                        $('.img_cntner').css('height', '300px');
                        $('#cropbox').addClass('portCropbox')
                    }
                }
            }
            var reader = new FileReader();
            reader.onload = function (e) {
                $('#cropbox').attr('src', e.target.result);
                $('#cropbox').Jcrop({
                    aspectRatio: 464 / 500,
                    setSelect: [0, 0, 200, 200],
                    boxWidth: 675,
                    allowResize: !0,
                    onSelect: updateCoords
                })
            };
            reader.readAsDataURL(file)
        };
        img.src = _URL.createObjectURL(file);
        $('.uploadImg-overlay').show();
        
}
function updateCoords(c) {
    $('#x').val(c.x);
    $('#y').val(c.y);
    $('#w').val(c.w);
    $('#h').val(c.h);
    responsiveCoords(c, '#cropbox');
};

function responsiveCoords(c, imgSelector) {
    var imgOrignalWidth = $(imgSelector).prop('naturalWidth');
    var imgOriginalHeight = $(imgSelector).prop('naturalHeight');

    var imgResponsiveWidth = parseInt($('.jcrop-holder').width());
    var imgResponsiveHeight = parseInt($('.jcrop-holder').parent().height());

    var responsiveX = Math.ceil((c.x / imgResponsiveWidth) * imgOrignalWidth);
    var responsiveY = Math.ceil((c.y / imgResponsiveHeight) * imgOriginalHeight);

    var responsiveW = Math.ceil((c.w / imgResponsiveWidth) * imgOrignalWidth);
    var responsiveH = Math.ceil((c.h / imgResponsiveHeight) * imgOriginalHeight);

    $('#rx').val(responsiveX);
    $('#ry').val(responsiveY);
    $('#rw').val(responsiveW);
    $('#rh').val(responsiveH);
}
export function ClosePopup(flag) {
    var ids;
    if(flag=="MB"){
        ids="mybumpie_upload";
    }else{
        ids="face_upload";
    }
    document.getElementsByClassName('uploadImg-overlay')[0].style.display = "none";
    document.getElementsByTagName('body')[0].style.overflow = 'visible';
    document.getElementById(ids).value = '';
    document.getElementsByClassName('img_cntner')[0].style.height = 'auto';
    document.querySelector(".img_cntner").style.width = "auto";
}
export function shareArticleFrame(articleurl, shareoption) {
    console.log("shareoption=================>", shareoption, articleurl);
    var shareurl;
    if (!articleurl.includes('http')) {
        articleurl = 'https:' + articleurl;
    }
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    // if(document.getElementsByClassName('share-overlay')){
    //     document.getElementsByClassName('share-overlay')[0].style.display = 'none';
    // }
    if (shareoption === "facebook") {
        shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (shareoption === "twitter") {
        shareurl = 'https://twitter.com/share?url=';
    } else if (shareoption === "pintrest") {
        shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    } else if (shareoption === "whatsapp") {
        shareurl = 'whatsapp://send?text=';
    }
    var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    console.log("sharewindow ",sharewindow);
    if (sharewindow.focus) {
        sharewindow.focus();
    }
    return false;
}
// export function uploadMemoryImgSubmit(file,flag,eleRef) {
//     var ids;
//     if(flag=="MB"){
//         ids="mybumpie_upload";
//     }else{
//         ids="face_upload";
//     }
//     var fileObj = document.getElementById(ids).files[0];
//     var apiurl = "";
//     document.getElementsByClassName('file_upload_err')[0].innerHTML = '';
//     if ((fileObj.type == "image/jpg" || fileObj.type == "image/jpeg" || fileObj.type == "image/png" || fileObj.type == "image/JPG") && file.size < 8388608) {
//         var file_name = Math.round(new Date().getTime() / 1000) + "_" + file.name;
//         apiurl = global.api_url + "uploadMemoryImage";
//         // apiurl = global.api_ci_url + "Parenting/uploadMemoryImage";
//     } else {
//         document.getElementsByClassName('uploadImg-overlay')[0].style.display = "none";
//         document.getElementsByTagName('body')[0].style.overflow = 'visible';
//         return document.getElementsByClassName('file_upload_err')[0].style.display = "inline-block",
//             document.getElementsByClassName('file_upload_err')[0].innerHTML = "Only JPEG, JPG and PNG files allowed",
//             document.getElementsByClassName('file_upload_err')[0].style.visibility = "visible",
//             document.getElementsByClassName('file_upload_err')[0].style.height = "30px";
//     }
//     service.postFileServiceCall(apiurl, file, file_name).then((json) => {
//         console.log("API Responce" + json['result'])
//         var dataAry = [];
//         dataAry.push(json['result']);
//         if (json['result'] == "success") {
//             console.log("success");
//             eleRef.setState({
//                 cropedImagePath: json['image_url'].replace("http://", "https://")
//             });
//             if (json['image_url']) {
//                 document.getElementById("main_frame").setAttribute("src", json['image_url'].replace("http://", "https://"));
//             } else {
//                 document.getElementsByClassName('file_upload_err')[0].style.visibility = "hidden";
//                 document.getElementsByClassName('file_upload_err')[0].style.height = "10px";
//                 document.getElementsByClassName('file_upload_err')[0].style.html = "";
//             }
//             document.querySelector('.add_photo_lbl').style.display = "none";
//             document.getElementsByClassName('photo_frame')[0].style.height = 'auto';
//             document.getElementsByClassName('photo_frame')[0].style.backgroundColor = '#fff';
//             document.getElementById('main_frame').style.display = "block";
//             document.querySelector('.choose_photo_btns').style.display = "none";
//             // document.querySelector('.face_day_container_uf').style.display = "none";
//             if(flag=="FB"){
//                 document.querySelector('.face_date_container_uf').style.display = "none";
//             }
//             document.querySelector('.upload_photo_btns').style.display = "block";
//             // document.getElementsByClassName('cancle_btn')[0].style.display="show";
//         } else {
//             console.log("API Responce sg sfd dsf gsdf");
//             document.getElementsByClassName('file_upload_err')[0].style.display = "block";
//             document.getElementsByClassName('file_upload_err')[0].style.visibility = "visible";
//             document.getElementsByClassName('file_upload_err')[0].style.height = "30px";
//             document.getElementsByClassName('file_upload_err')[0].innerHTML = json['result'];
//         }
//         clearMemoryImageData(ids);
//         document.getElementsByClassName("loader-overlay")[0].style.display = "none";
//     })
// }



// WEBPACK FOOTER //
// src/shared/tools/Actions.js